import { generateTableSlice } from "./sliceTable";

const sliceInsuranceTable = generateTableSlice("insurance");

export const ActionsInsuranceTable = sliceInsuranceTable.actions;
export const ReducerInsuranceTable = sliceInsuranceTable.reducer;
